/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable no-useless-escape */
import DateUtil from './DateUtil';

function isNonEmptyString(text) {
  return text !== '' && text !== null && text !== undefined;
}

function validateEmail(value) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
}

function validateDate(locale, dateValue, dateFormat) {
  return DateUtil.isValidDate(locale, dateValue, dateFormat);
}

function getMessageIfInvalid(value, validation, invalidMessage) {
  return validation(value) ? '' : invalidMessage;
}

function isProfileNameValid(preferredName, givenName, familyName) {
  const hasPreferredName = isNonEmptyString(preferredName);
  const hasGivenName = isNonEmptyString(givenName);
  const hasFamilyName = isNonEmptyString(familyName);
  return hasPreferredName && (hasGivenName || hasFamilyName);
}

function isValidGender(genderId) {
  return !!genderId;
}

function isValidSingleValueNumber(value, options = {}) {
  const regex = options.allowPrefixes
    ? /(^[-><]?\d+(\.\d+)?$)/
    : /(^\d+(\.\d+)?$)/;
  return regex.test(value);
}

function isWholeNumber(value) {
  const regex = /^\d+$/;
  return regex.test(value);
}

function isValidTwoValueNumber(value, options = {}) {
  const allowSlash = options.allowSlash ? '\\/' : '';
  const allowPrefixes = options.allowPrefixes ? '[><]?' : '';
  const digit = `(${allowPrefixes}\\d+(\\.\\d+)?)`;
  const regString = `^${digit}[-${allowSlash}]{1}${digit}$`;
  const regex = new RegExp(regString);

  const isValid = regex.test(value);
  if (value.indexOf('-') > -1) {
    if (isValid) {
      const parts = value.split('-');
      return Number(parts[0]) < Number(parts[1]);
    }
    return false;
  }

  return isValid;
}

function isRange(value) {
  const digit = `\\d+(\\.\\d+)?`;
  const regString = `(^${digit}[-]{1}${digit}$)`;
  const regex = new RegExp(regString);
  return regex.test(value);
}
function isValidNumberOrRange(value, options) {
  if (typeof value === 'number') { return true; }
  const strippedValue = value.replace(/[\s]+/g, '');
  return isValidSingleValueNumber(strippedValue, options) || isValidTwoValueNumber(strippedValue, options);
}

function isValidFrequency(value) {
  return isValidNumberOrRange(value, { allowSlash: false })
}
function isValidHealthEntryValueAmount(val) {
  // allow values with / for Labs and Measurements
  const parts = val.split('|').filter(v => v !== '');
  return parts.reduce((acc, v) => {
    const strippedValue = v.replace(/[\s]+/g, '');

    return acc && (
      isValidSingleValueNumber(strippedValue, { allowPrefixes: true }) || isValidTwoValueNumber(strippedValue, { allowSlash: true, allowPrefixes: true })
    )
  }, true);
}
function isValidTrackableQuantity(val) {
  // allow values with /
  const parts = val.split('|').filter(v => v !== '');
  return parts.reduce((acc, v) => {
    const strippedValue = v.replace(/[\s]+/g, '');

    return acc && (
      isValidSingleValueNumber(strippedValue, { allowPrefixes: true }) || isValidTwoValueNumber(strippedValue, { allowSlash: true, allowPrefixes: true })
    )
  }, true);
}

function isValidMedicationAmount(val) {
  // do not allow /
  // disallow amounts starting with >, <, - for Medications
  const parts = val.split('|');
  return parts.reduce((acc, v) => {
    const strippedValue = v.replace(/[\s]+/g, '');

    return acc && (
      isValidSingleValueNumber(strippedValue, { allowPrefixes: false }) || isValidTwoValueNumber(strippedValue, { allowSlash: false })
    )
  }, true);
}

function isValidObservationQuantity(val) {
  // allow values with / for Labs and Measurements
  const strippedValue = val.replace(/[\s]+/g, '');

  return isValidSingleValueNumber(strippedValue, { allowPrefixes: true }) || isValidTwoValueNumber(strippedValue, { allowSlash: true, allowPrefixes: true })
}


export {
  validateEmail,
  getMessageIfInvalid,
  validateDate,
  isProfileNameValid,
  isValidGender,
  isRange,
  isValidNumberOrRange,
  isWholeNumber,
  isValidHealthEntryValueAmount,
  isValidTrackableQuantity,
  isValidMedicationAmount,
  isValidFrequency,
  isValidObservationQuantity,
};
